
import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

const Banner = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="bg-accent text-accent-foreground px-4 py-3 text-center relative flex items-center justify-between">
      <p className="text-sm font-medium flex-grow">
        Please note: August 15th is an Austrian National Holiday! Plan your travel accordingly.
      </p>
      <Button 
        variant="ghost" 
        size="icon" 
        onClick={() => setIsVisible(false)} 
        className="ml-4"
        aria-label="Close banner"
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default Banner;
